import { Pipe, PipeTransform } from '@angular/core';

/**
 * @author Abdulqodir
 * @dateCreated 11 Jul 2024
 * @description A pipe that formats a number by adding commas as thousand separators.
 */

@Pipe({
  name: 'numberFormatter',
  pure: false,
})
export class NumberFormatterPipe implements PipeTransform {
  transformedValue: string;
  transform(value: any, ...args: any[]): string {
    if (value === null) this.transformedValue = '';
    this.transformedValue = new Intl.NumberFormat().format(value);
    return this.transformedValue;
  }
}
